import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'projul-spinner',
  templateUrl: './spinner.component.html',
  styleUrls: ['./spinner.component.scss']
})
export class SpinnerComponent implements OnInit {

  @Input() isSpinner: boolean = false;
  @Input() text: string = '';
  constructor() { }

  ngOnInit(): void {
  }

}
